<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/crazy-card/resgate">Resgate de Benefícios</router-link>
          </li>          
          <li class="item-link">
            <span>Detalhe N° {{$route.params.id}}</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area segunda-via">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">
              Resgate de Benefícios - N°
              <span>{{$route.params.id}}</span>
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <p>Data Solicitação:</p>
          </div>
          <div class="col-md-10">
            <strong>{{solicitacao.data}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <p>Situação:</p>
          </div>
          <div class="col-md-10">
            <strong>{{solicitacao.dataAprovacao}}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <vue-good-table
              :columns="columns"
              :rows="solicitacao.produtos"
              :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        perPage: 20,
                        position: 'top',
                        perPageDropdown: [40, 60],
                        dropdownAllowAll: false,
                        setCurrentPage: 1,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Linhas por página',
                        ofLabel: 'de',
                        pageLabel: 'page',
                        allLabel: 'Todos',
                    }"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.type == 'decimal'"
                >{{formatCurrency(props.formattedRow[props.column.field])}}</span>
                <router-link
                  v-else-if="props.column.field == 'id'"
                  v-bind:to="{ name: 'crazy-rescue-detail', params: { id: props.formattedRow[props.column.field] }}"
                >
                  <i class="fa fa-eye"></i>
                </router-link>
                <span v-else>{{props.formattedRow[props.column.field]}}</span>
              </template>
              <div slot="emptystate">Sem dados para exibição</div>
            </vue-good-table>
            <div class="panel panel-default">
              <div class="panel-heading" style="text-align: end; font-weight: bold">Total: {{formatCurrency(solicitacao.soma)}}</div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="alert alert-warning" role="alert">
                    <p>INFORMAÇÕES IMPORTANTES </p>
                    <ul class="Style2">
                        <li><i class="fa fa-check"></i> Solicitações não finalizadas, são canceladas automaticamente, 24 em horas; </li>
                        <li><i class="fa fa-check"></i> Toda solicitação de produto seguirá bonificado para sua empresa juntamente com o seu próximo pedido; </li>
                        <li><i class="fa fa-check"></i> A partir da data da colocação de sua solicitação, você terá 3 dias corridos, para realizar seu próximo pedido na Aldo, no qual os itens bonificados seguirão, conforme descrito no ponto acima. Após esta data limite, a solicitação é cancelada e o crédito de Aldolar é devidamente estornado; </li>
                        <li><i class="fa fa-check"></i> Para solicitações de verbas de marketing é obrigatória a leitura do <a :href="`${$SiteUrl}/Arquivos/CrazyCard/Guia_Aldo_Crazy_Card.pdf`" target="_blank">GUIA DE BENEFÍCIOS ALDO CRAZY CARD.</a></li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "CrazyRescueDetail",
  components: {
    VueGoodTable
  },  
  data() {
    return {
      solicitacao: {
        soma: 0,
        data: "",
        situacao: "",
        dataAprovacao: "",
        produtos : []
      },
      columns: [
        { label: "Código", field: "codigo" },
        { label: "Descrição", field: "descricao" },
        { label: "Qtde", field: "qtde" },
        { label: "Valor Unitário", field: "vlUnit", type: "decimal" },
        { label: "Valor Total", field: "vlTotal", type: "decimal" }
      ]
    };
  },
  mounted() {
    this.solicitacao.produtos = []

    const self = this

    var xhr = new XMLHttpRequest()
    xhr.onload = () => {
      if (xhr.status == 200){
        let json = JSON.parse(xhr.responseText)
        
        json.forEach((element, index) => {
          if (index === 0){
            this.solicitacao.data = element.SolicitacaoData
            this.solicitacao.dataAprovacao = element.Situacao
          }

          let produto = {}
          produto.codigo = element.CraCodigo
          produto.descricao = element.CraDescricao
          produto.qtde = element.Qtde
          produto.vlUnit = element.ValorUnitario
          produto.vlTotal = element.ValorTotal
          this.solicitacao.produtos.push(produto)

          this.solicitacao.soma += element.ValorTotal
        })
      }
      else if (xhr.status == 401){
        swal({
          title: "É necessário estar logado",
          icon: "warning"
        }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
      }
    }

    xhr.open("GET", this.$apiUrl + "Resgate.svc/getsolicitacao/" + this.$route.params.id)
    xhr.setRequestHeader("Content-type", "application/json")
    xhr.withCredentials = true
    xhr.send();
  },
  methods :{
    formatCurrency: function(v) {
      v = v.toString().replace(',','.')
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato).replace("R$", "A$");
    }      
  }
};
</script>
